<div class="page-section">

  <p class="page-heading">Zoom App Documentation</p>

  <p class="page-description">
    Welcome to the WealthGrowth.AI documentation page. This guide will help you add, use, and remove the WealthGrowth.AI app from your Zoom account, along with troubleshooting common issues and accessing support.</p>

  <p class="page-description-heading">Adding the App</p>
  <p class="page-description-sub-heading">Step-by-Step Guide to Add WealthGrowth.AI to Your Zoom Account</p>
  <p class="page-description-sub-head">1.	Login to Zoom:</p>
  <ul>
    <li>
        <span>Navigate to Zoom and log in to your account.</span>
    </li>
  </ul>
  <p class="page-description-sub-head">2.	Access the Zoom App Marketplace:</p>
  <ul>
    <li>
        <span>Go to the Zoom App Marketplace.</span>
    </li>
  </ul>
  <p class="page-description-sub-head">3.	Search for WealthGrowth.AI:</p>
  <ul>
    <li>
        <span>In the search bar, type "WealthGrowth.AI" and press Enter</span>
    </li>
  </ul>
  <p class="page-description-sub-head">4.	Select WealthGrowth.AI:</p>
  <ul>
    <li>
        <span>Click on the WealthGrowth.AI app from the search results.</span>
    </li>
  </ul>
  <p class="page-description-sub-head">5.	Add the App:</p>
  <ul>
    <li>
        <span>Click the "Install" button.</span>
    </li>
    <li>
      <span>Follow the on-screen prompts to authorize the app.</span>
  </li>
  </ul>
  <p class="page-description-sub-head">6.	Complete Installation:</p>
  <ul>
    <li>
        <span>Once authorized, the app will be added to your Zoom account and you can start using it.</span>
    </li>
  </ul>


  <p class="page-description-heading">Features and Use-Cases</p>
  <p class="page-description-sub-heading">Scheduling Zoom Meetings</p>
  <p class="page-description-sub-head">Use-Case Description:</p>
  <ul>
    <li>
        <span>Schedule Zoom meetings directly from the WealthGrowth.AI platform.</span>
    </li>
  </ul>
  <p class="page-description-sub-head">Prerequisites:</p>
  <ul>
    <li>
        <span>Ensure your WealthGrowth.AI account is connected to your Zoom account.</span>
    </li>
  </ul>

  <p class="page-description-heading">Removing the App</p>
  <p class="page-description-sub-heading">Guide to Remove WealthGrowth.AI from Your Zoom Account</p>
  <p class="page-description-sub-head">1.	Login to Zoom:</p>
  <ul>
    <li>
        <span>Navigate to Zoom and log in to your account.</span>
    </li>
  </ul>
  <p class="page-description-sub-head">2.	Navigate to Added Apps</p>
  <ul>
    <li>
        <span>Go to the Zoom App Marketplace.</span>
    </li>
    <li>
      <span>Click "Manage" >> "Added Apps".</span>
  </li>
  </ul>
  <p class="page-description-sub-head">3.	Select WealthGrowth.AI:</p>
  <ul>
    <li>
        <span>Search for "WealthGrowth.AI" in the list of added apps.</span>
    </li>
    <li>
      <span>Click on the WealthGrowth.AI app.</span>
  </li>
  </ul>
  <p class="page-description-sub-head">4.	Remove the App:</p>
  <ul>
    <li>
        <span>Click "Remove".</span>
    </li>
  </ul>

  <p class="page-description-heading">Implications of Removing the App</p>
  <ul>
    <li>
        <span>Removing the WealthGrowth.AI app will revoke its access to your Zoom account.</span>
    </li>
    <li>
      <span>Any scheduled meetings created through WealthGrowth.AI will remain in your Zoom account.</span>
  </li>
  <li>
    <span>Your data in WealthGrowth.AI will be retained as per our data retention policy. For data deletion requests, contact support.</span>
  </li>
  </ul>

  <p class="page-description-heading">Troubleshooting</p>
  <p class="page-description-sub-heading">Common User Issues and Solutions</p>
  <p class="page-description-sub-head">1.	Issue: Unable to Add the App</p>
  <ul>
    <li>
        <span>Ensure you have admin privileges in Zoom.</span>
    </li>
    <li>
      <span>Check your network connection.</span>
  </li>
  </ul>
  <p class="page-description-sub-head">2.	Issue: Issues Scheduling Meetings</p>
  <ul>
    <li>
        <span>Ensure your Zoom account is connected to WealthGrowth.AI.</span>
    </li>
    <li>
      <span>Verify the meeting details and try again.</span>
  </li>
  <li>
    <span>Contact support if the issue persists.</span>
  </li>
  </ul>


  <p class="page-description-heading">FAQ</p>
  <p class="page-description-sub-head">1.	How do I authorize WealthGrowth.AI?</p>
  <ul>
    <li>
        <span>Follow the steps in the "Adding the App" section.</span>
    </li>
  </ul>
  <p class="page-description-sub-head">2.	Why am I not receiving activation emails?</p>
  <ul>
    <li>
        <span>Check your spam/junk folder.</span>
    </li>
    <li>
      <span>Ensure you entered the correct email address.</span>
  </li>
  </ul>

  <p class="page-description-heading">Contact Support</p>
  <p class="page-description-sub-head">Support Hours:</p>
  <ul>
    <li>
        <span class="day">Monday to Friday : </span>
        <span class="time">9:00 AM to 6:00 PM (EST)</span>
    </li>
    <li>
        <span class="day">Saturday : </span>
        <span class="time">10:00 AM to 4:00 PM (EST)</span>
    </li>
    <li>
        <span class="day">Sunday : </span>
        <span class="time">Closed</span>
    </li>
</ul>

  <p class="page-description-sub-head">First Response SLA:</p>
  <ul>
    <li>
        <span>We aim to respond to all support inquiries within 24 hours during our hours of operation.</span>
    </li>
  </ul>

</div>
